import axios from 'axios';

export const obtenerUbicacionUsuario = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    let location = null;

    try {
        if (res !== null && res != undefined) {
            location = {
                countryCode: res.data.country_code === null ? "" : res.data.country_code,
                countryName: res.data.country_name === null ? "" : res.data.country_name,
                city: res.data.city === null ? "" : res.data.city,
                postal: res.data.postal === null ? "" : res.data.postal,
                state: res.data.state === null ? "" : res.data.state,
                latitude: res.data.latitude === null ? "" : res.data.latitude,
                longitude: res.data.longitude === null ? "" : res.data.longitude,
                ipv4: res.data.IPv4 === null ? "" : res.data.IPv4
            }
        }
    } catch (e) {
        location = {
            countryCode: "",
            countryName: "",
            city: "",
            postal: "",
            state: "",
            latitude: 0,
            longitude: 0,
            ipv4: ""
        }
    }

    return location;
}


